import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateUtilityRateRequest,
  UpdateUtilityRateRequest,
  UtilityRate,
} from '../../model/utility-rate.model';

export const UTILITY_RATES_URL = `${environment.apiBaseAdminUrl}/utility-rates`;

@Injectable({ providedIn: 'root' })
export class UtilityRateService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<UtilityRate[]> {
    return this.http.get<UtilityRate[]>(UTILITY_RATES_URL);
  }

  getById(id: number): Observable<UtilityRate> {
    return this.http.get<UtilityRate>(`${UTILITY_RATES_URL}/${id}`);
  }

  create(payload: CreateUtilityRateRequest): Observable<UtilityRate> {
    return this.http.post<UtilityRate>(UTILITY_RATES_URL, payload);
  }

  update(id: number, payload: UpdateUtilityRateRequest): Observable<UtilityRate> {
    return this.http.put<UtilityRate>(`${UTILITY_RATES_URL}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${UTILITY_RATES_URL}/${id}`);
  }
}
